export default "__VITE_ASSET__DX0X5fqK__"